var toString = require('../lang/toString');
    /**
     * Checks if string starts with specified prefix.
     */
    function startsWith(str, prefix) {
        str = toString(str);
        prefix = toString(prefix);

        return str.indexOf(prefix) === 0;
    }

    module.exports = startsWith;




//////////////////
// WEBPACK FOOTER
// ./~/mout/string/startsWith.js
// module id = 1678
// module chunks = 0 1 2